import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Search, ExternalLink, BookmarkPlus } from "lucide-react";

export default function Resources() {
  const [data, setData] = useState({ resources: [], categories: [] });
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("All");

  const load = () => {
    const p = new URLSearchParams();
    if (q) p.set("q", q);
    if (cat !== "All") p.set("category", cat);
    api.get(`/resources?${p.toString()}`).then((r) => setData(r.data)).catch(() => {});
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [q, cat]);

  const save = async (r) => {
    const { data } = await api.post("/saved", { type: "resource", ref_id: r.name, title: r.name, meta: { url: r.url } });
    toast.success(data.saved ? "Added to favorites" : "Removed");
  };

  return (
    <div className="space-y-8" data-testid="resources-page">
      <div>
        <span className="font-mono-eco text-xs uppercase tracking-widest text-slate-500">Resource Vault</span>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-white tracking-tight mt-1">The best official resources, curated.</h1>
        <p className="text-slate-400 mt-2">Hand-picked links from Y Combinator, a16z, Stripe, Google and more.</p>
      </div>

      <div className="relative max-w-md">
        <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500" />
        <input data-testid="resources-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search resources…" className="eco-input pl-10" />
      </div>

      <div className="flex flex-wrap gap-2">
        {["All", ...data.categories].map((c) => (
          <button key={c} data-testid={`res-cat-${c}`} onClick={() => setCat(c)} className={`text-xs font-medium px-3 py-1.5 rounded-full border transition-all ${cat === c ? "bg-white text-black border-white" : "border-white/10 text-slate-400 hover:bg-white/5"}`}>{c}</button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {data.resources.map((r) => (
          <div key={r.name} className="eco-card eco-card-hover p-5 flex flex-col" data-testid={`resource-${r.name}`}>
            <div className="flex items-start justify-between gap-2">
              <span className="eco-tag">{r.category}</span>
              <button onClick={() => save(r)} data-testid={`save-res-${r.name}`} className="text-slate-500 hover:text-[#4d8bff]"><BookmarkPlus size={16} /></button>
            </div>
            <h3 className="font-display font-semibold text-white mt-3">{r.name}</h3>
            <p className="text-sm text-slate-400 mt-1.5 flex-1">{r.description}</p>
            <a href={r.url} target="_blank" rel="noopener noreferrer" className="btn-secondary text-sm mt-4 self-start">Visit <ExternalLink size={14} /></a>
          </div>
        ))}
        {data.resources.length === 0 && <p className="text-slate-500 col-span-full text-center py-12">No resources found.</p>}
      </div>
    </div>
  );
}
